import {
  RadioGroup as ChakraRadioGroup,
  CheckboxGroup as ChakraCheckboxGroup,
} from '@chakra-ui/react';
import React, { useState } from 'react';

import { useKeyPress } from '@frontend/utils';

import { SelectionProvider } from '../utils/selectHelpers';

const MultiSelectionWrapper = ({ selected, onSelect, children }) => {
  const [lastSelected, setLastSelected] = useState(null);
  const shiftPressed = useKeyPress('Shift');
  return (
    <ChakraCheckboxGroup value={selected} onChange={onSelect}>
      <SelectionProvider
        value={{
          selected,
          onSelect,
          shiftPressed,
          lastSelected,
          setLastSelected,
        }}
      >
        {children}
      </SelectionProvider>
    </ChakraCheckboxGroup>
  );
};

const SingleSelectionWrapper = ({ selected, onSelect, children }) => {
  return (
    <ChakraRadioGroup value={selected} onChange={onSelect}>
      <SelectionProvider
        value={{
          selected,
          onSelect,
        }}
      >
        {children}
      </SelectionProvider>
    </ChakraRadioGroup>
  );
};

/**
 * @deprecated use TableV2 and its subcomponents from '@frontend/components' instead.
 */
const SelectionWrapper = ({ selected, onSelect, useRadios, children }) => {
  if (onSelect == null) {
    return <>{children}</>;
  }

  if (useRadios) {
    return (
      <SingleSelectionWrapper selected={selected} onSelect={onSelect}>
        {children}
      </SingleSelectionWrapper>
    );
  } else {
    return (
      <MultiSelectionWrapper selected={selected} onSelect={onSelect}>
        {children}
      </MultiSelectionWrapper>
    );
  }
};

export default React.memo(SelectionWrapper);
